import Page from '../../components/layouts/page'
import CategoriesTable from '../../components/categories_table'
import { useParams } from 'react-router-dom'
import { Button, ButtonDropdown } from '@bitcine/cinesend-theme/dist'
import useStore from '../../hooks/use_store'
import axios from 'axios'
import openInNewTab from '../../helpers/openinnewtab'
import { useState } from 'react'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import useAuth from '../../hooks/use_auth'
import { modelTypes } from '../../constants/model_types'
import CreateForm from './create_form'

const Categories = () => {
  const params = useParams()
  const { createModel } = useStore()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [showCreateModal, setShowCreateModal] = useState(false)
  const { data: airline } = useQuery(['airlines/', params.airlineID])
  const { data: cycle } = useQuery(['cycles/', params.cycleID])
  const langID = airline?.languages?.[0]?.id || null
  const queryClient = useQueryClient()
  const queryKey = `/categories?cycleID=${params.cycleID}`
  const { canEditModel: canEditCategory } = useAuth(modelTypes.Category)

  const closeModal = () => {
    setIsModalOpen(false)
    queryClient.invalidateQueries([queryKey])
  }

  const exportCategories = ({ isTemplate }) => {
    createModel.mutate(
      {
        endpoint: 'exports',
        data: {
          name: `export-cycle-${params.cycleID}-type-category`,
          cycleID: params.cycleID,
          type: 'category',
          isTemplate,
          langID,
        },
      },
      {
        onSuccess: (res) => {
          if (res.data) {
            axios.get(`${process.env.VITE_API_URL}/exports/${res.data.export.id}/download`).then((r) => {
              openInNewTab(r.data.url)
            })
          }
        },
      }
    )
  }
  return (
    <Page
      title={'Categories'}
      buttons={[
        <div key={'asset-buttons'} className='space-x-2 flex items-center'>
          {canEditCategory && (
            <Button icon='category' disabled={!!cycle?.is_locked} onClick={() => setShowCreateModal('categories')}>
              Create Section
            </Button>
          )}
          <Button icon='list' disabled={!!cycle?.is_locked} onClick={() => setShowCreateModal('assets')}>
            Create Asset Category
          </Button>
          {/* <ButtonDropdown
            button={{
              text: 'Export',
              icon: 'cloud_download',
            }}
            dropdown={{
              content: [
                {
                  text: 'Export Template',
                  onClick: () => exportCategories({ isTemplate: true }),
                },
                {
                  text: 'Export Populated',
                  onClick: () => exportCategories({ isTemplate: false }),
                },
              ],
            }}
          />
          <Button icon='cloud_upload' onClick={() => setIsModalOpen(true)}>
            import
          </Button> */}
        </div>,
      ]}
    >
      <CategoriesTable queryKey={queryKey} />
      {/* {isModalOpen && (
        <ImportForm isOpen={isModalOpen} onClose={closeModal} cycleID={params.cycleID} assetType={'category'} />
      )} */}
      {!!showCreateModal && (
        <CreateForm
          isOpen={!!showCreateModal}
          onClose={() => setShowCreateModal(false)}
          cycleID={params.cycleID}
          createModel={createModel}
          categoryType={showCreateModal}
        />
      )}
    </Page>
  )
}

export default Categories
